module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "top": "",
      "color": _vm.color,
      "multi-line": _vm.mode === 'multi-line',
      "timeout": _vm.timeout,
      "vertical": _vm.mode === 'vertical'
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.text) + "\n    "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("\n        Close\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3b98f12f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Snackbar.vue
// module id = 607
// module chunks = 1